import { FC, useEffect } from 'react';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import {
  StyledDatePickerTextField,
  StyledDatePickerPaper,
  CalendarIcon,
} from '../StyledComponents/StyledDatePicker';
import { DATE_FORMATS } from 'src/utils/properties.utils';
import { Box, Typography } from '@mui/material';

interface CreatedDatePickerProps {
  fontSize?: string;
  color?: string;
  fontWeight?: string;
  width?: string;
  height?: string;
  placeholder?: string;
  borderColor?: string;
  errorState?: boolean;
  formikProps?: any;
  name: string;
  label?: string;
  showLabel?: boolean;
  mb?: number;
}

const CreatedDatePicker: FC<CreatedDatePickerProps> = ({
  fontSize = '14px',
  color = 'var(--primary-navy)',
  fontWeight = '400',
  width = '150px',
  height = '28px',
  placeholder = 'Select a date',
  borderColor = 'var(--hover-white)',
  errorState = false,
  formikProps = {},
  name,
  label,
  showLabel = false,
  mb = 1,
}) => {
  const { values, setFieldValue, touched, errors } = formikProps;

  useEffect(() => {
    if (values[name] === null) {
      setFieldValue(name, null);
    }
  }, [name, values, setFieldValue]);
  const hasError = errorState || (touched[name] && Boolean(errors[name]));

  return (
    <Box mb={mb}>
      {showLabel && (
        <Typography
          fontFamily="Outfit"
          fontWeight="400"
          fontSize="16px"
          color={color}
          mb={2}
        >
          {label}
        </Typography>
      )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={values[name] ? dayjs(values[name]) : null}
          onChange={(newValue) =>
            setFieldValue(name, newValue ? newValue.toDate() : null)
          }
          format={DATE_FORMATS.API}
          slotProps={{
            textField: {
              placeholder: placeholder,
              fontSize: fontSize,
              color: color,
              fontWeight: fontWeight,
              width: width,
              height: height,
              borderColor: borderColor,
              hasError: hasError,
            } as any,
            desktopPaper: {
              component: StyledDatePickerPaper,
            } as any,
          }}
          slots={{
            textField: StyledDatePickerTextField,
            openPickerIcon: () => <CalendarIcon className="bx bx-calendar" />,
          }}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default CreatedDatePicker;
